// extracted by mini-css-extract-plugin
export default {"unclaimedDisclaimerSection":"unclaimedDisclaimerSection__NGRlO","tooltipIcon":"tooltipIcon__ZjRiN"};